import React from 'react';
import Styled from 'styled';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import SVGIcon from 'lib/images/svg-icon/svg-icon';

import { ViewerConsumer } from 'four-nets/user/viewer/viewer';
import iconNewArticle from 'four-nets/icons/svg/icon_new-article.svg';
import iconGallery from 'four-nets/icons/svg/icon_gallery.svg';
import { PostType } from 'four-nets/photoblog/posts/common/feed-images/feed-images.graphql.types';
import Avatar from 'four-nets/avatar/avatar';
import AddImages from 'four-nets/photoblog/posts/album/edit/add-images/add-images';
import { displayedName } from 'four-nets/user/utils';

import { AuthorTopFragment } from './author-top.graphql';
import defaultStyles from './author-top.scss';

export interface Props extends AuthorTopFragment {
    styles: typeof defaultStyles;
}

class AuthorTop extends React.PureComponent<Props> {
    render() {
        const { styles, ...rest } = this.props;
        const { user, slug } = rest;
        let photoBlogPostsCount: number | null = 0;
        if (!user) {
            return null;
        }
        photoBlogPostsCount = user.photoBlogPostsCount;

        const { profile } = user;

        const userBlogLink =
            profile && profile.isVendor ? `/catalog/vendor/${user.username}` : `/blog/${user.username}`;
        const username =
            profile && profile.isVendor && profile.vendor && profile.vendor.name
                ? profile.vendor.name
                : displayedName(user);

        return (
            <ViewerConsumer>
                {({ viewer }) =>
                    viewer && viewer.username === user.username ? (
                        <>
                            <AddImages {...(rest as any)} />
                            <Link
                                to={
                                    user.profile!.isVendor
                                        ? `/catalog/vendor/${user.username}/blog-album/${slug}/edit`
                                        : `/blog/${user.username}/album/${slug}/edit/`
                                }
                                className={styles.editLink}
                            >
                                <SVGIcon style={{ image: styles.icon }} src={iconNewArticle} />
                                <span className={styles.editAbumLabel}>
                                    <FormattedMessage id='CHANGE_DATE_TITLE_AND_DESCRIPTION' values={{ gender: 'v' }} />
                                </span>
                            </Link>
                            <Link
                                to={
                                    user.profile!.isVendor
                                        ? `/catalog/vendor/${user.username}/blog-album/${slug}/edit-photos`
                                        : `/blog/${user.username}/album/${slug}/edit-photos/`
                                }
                                className={styles.editLink}
                            >
                                <SVGIcon style={{ image: styles.icon }} src={iconGallery} />
                                <span className={styles.editAbumLabel}>
                                    <FormattedMessage id='EDIT_ALBUM_PHOTOS' />
                                </span>
                            </Link>
                        </>
                    ) : (
                        <div className={styles.wrapper}>
                            <div className={styles.avatarWrapper}>
                                <Avatar style={{ avatar: styles.avatar }} user={user} />
                            </div>
                            <div className={styles.content}>
                                <div className={styles.title}>
                                    <Link to={userBlogLink} className={styles.userLink}>
                                        {username}
                                    </Link>
                                </div>
                                <div className={styles.count}>
                                    <FormattedMessage
                                        id='%(number)s_ALBUMS'
                                        values={{ number: photoBlogPostsCount || 0 }}
                                    />
                                </div>
                                <Link to={`${userBlogLink}/?post_type=${'POST_ALBUM'}`} className={styles.link}>
                                    <FormattedMessage id='MORE_ALBUMS' />
                                </Link>
                            </div>
                        </div>
                    )
                }
            </ViewerConsumer>
        );
    }
}

export default Styled(defaultStyles)(AuthorTop);
